import withDirection from 'src/settings/withDirection';
import styled, { css, keyframes } from 'styled-components';
import { palette } from 'styled-theme';

export const Wrapper = styled('div')`
  display: flex;
  justify-content: center;
  margin-top: 12px;
  padding: 0 6px;
`;

const revealAfterExpand = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

const revealAfterExpandAnimation = css`
  animation: ${revealAfterExpand} 0.1s 0.2s both;
`;

export const Button = styled('button')`
  display: flex;
  align-items: center;
  width: 100%;
  margin: 0 auto;
  height: 36px;
  background-color: ${palette('globalSearch', 1)};
  border-radius: 6px;
  padding: 7px 10px;
  border: 1px solid ${palette('border', 1)};
  cursor: pointer;
`;

const IconStyles = styled('div')`
  color: ${palette('grayscale', 7)};
  font-weight: 500;
  font-size: 16px;
  display: flex;
  align-items: center;
  margin-left: ${props => (props['data-rtl'] === 'rtl' ? '16px' : '0')};
  margin-right: ${props => (props['data-rtl'] === 'rtl' ? '0' : '16px')};

  svg {
    margin-left: -1px;
  }
`;

const SearchTextStyles = styled('span')`
  ${revealAfterExpandAnimation}
  font-size: 14px;
  color: ${palette('globalSearch', 2)};
  flex-grow: 1;
  text-align: ${props => (props['data-rtl'] === 'rtl' ? 'right' : 'left')};
`;

export const ShortcutsContainer = styled('div')`
  ${revealAfterExpandAnimation}
  display: flex;
  gap: 3px;
`;

export const ShortcutKey = styled('div')`
  width: 16px;
  height: 16px;
  background-color: ${palette('globalSearch', 3)};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  color: ${palette('grayscale', 7)};

  &.key-windows {
    width: 36px;
  }
`;

export const Icon = withDirection(IconStyles);
export const SearchText = withDirection(SearchTextStyles);
